/**
 * @description : Intercepts every request and appends required headers.
 * @requires {Object} configService
 * @requires {Object} applicationModel
 * @requires {Promise} $q
 * @requires {Object} $cookies
 * @requires {Object} $rootScope
 * @requires {Object} $timeout
 **/
function requestInterceptor(configService, applicationModel, $q, $cookies, $rootScope, $timeout) {

  const ERROR_MESSAGE = configService.messages.system_error.tracking_unavailable;

  /**
   * @description: Re-submit number depending on error code.
   * @param {Object} response
   */
  function checkErrorResubmit(response) {

    const errorCodeResubmit = 'E0015';

    if (angular.isDefined(response.data.errors[0].errorCode)) {

      if (response.data.errors[0].errorCode === errorCodeResubmit) {

        $timeout(() => {

          if (applicationModel && applicationModel.googleRecaptcha) {

            // Clear sessionToken for next request.
            applicationModel.googleRecaptcha.sessionToken = null;
            $rootScope.$emit('externalReSubmit', applicationModel.sanitizedNumber);

          }

        }, 100);

      }

    }

  }

  return {

    request: (request) => {

      /**
       * @description : Add specific headers for when a reCAPTCHA system is
       * used.
       **/
      function addRecaptchaHeaders() {

        if (applicationModel.googleRecaptcha.sessionToken) {

          // TODO: Remove deprecated "X-Recaptcha-Session" once APIm 3.2 is deployed.
          request.headers['X-Recaptcha-Session'] = applicationModel.googleRecaptcha.sessionToken;
          request.headers['X-RMG-API-Session'] = applicationModel.googleRecaptcha.sessionToken;

        } else if (applicationModel.googleRecaptcha.googleToken) {

          // TODO: Remove deprecated "X-Recaptcha-Response" header once APIm 3.2 is deployed.
          request.headers['X-Recaptcha-Response'] = applicationModel.googleRecaptcha.googleToken;
          request.headers['X-RMG-Recaptcha'] = applicationModel.googleRecaptcha.googleToken;
          // We want to get rid of googleToken as we assume it would be used and invalidated.
          delete applicationModel.googleRecaptcha.googleToken;

        }

      }

      request.headers['X-IBM-Client-ID'] = configService.api.ibm_client_id;
      request.headers['Accept-Language'] = document.documentElement.lang;
      request.headers['X-RMG-Language'] = document.documentElement.lang === 'en' ? 'en_GB' : 'cy_CY';

      if (applicationModel.authToken) {

        request.headers['X-RMG-Auth-Token'] = `Bearer ${$cookies.get('parcels_jwt')}`;

      }

      if (angular.isDefined(request.isWithCredentialRequired)
          && request.isWithCredentialRequired) {

        // withCredentials is often required when we need to receive set/send
        // a cookie.
        request.withCredentials = true;

      }

      if (applicationModel.macSessionHeader) {

        request.headers['X-RMG-MAC'] = applicationModel.macSessionHeader;

        // Reset applicationModel MAC once added to the Header.
        applicationModel.macSessionHeader = false;

      } else if (angular.isDefined(request.isgetRecaptchaHeadersRequired)
          && request.isgetRecaptchaHeadersRequired) {

        addRecaptchaHeaders();

      }

      request.timeout = configService.api.script_timeout;
      return request;

    },

    response: (response) => {

      // TODO: Remove deprecated "X-Recaptcha-Session" once APIm 3.2 is deployed.
      const recaptchaSession = response.headers('X-RMG-API-Session') || response.headers('x-recaptcha-session');

      // Set the cookie as session cookie as we check if is valid later in the code.
      if ((recaptchaSession !== undefined) && (recaptchaSession !== null)) {

        // TODO: Remove deprecated "X-Recaptcha-Session" once APIm 3.2 is deployed.
        $cookies.put('x-recaptcha-session', recaptchaSession, { secure: true, path: '/' });
        $cookies.put('X-RMG-API-Session', recaptchaSession, { secure: true, path: '/' });
        applicationModel.googleRecaptcha.sessionToken = recaptchaSession;

      }

      // Quick sanity check to see if we have any data
      if (Object.keys(response).length === 0) {

        return $q.reject(ERROR_MESSAGE);

      }

      // If response contains an error or errors, reject the promise.
      if (angular.isDefined(response.data) &&
        (angular.isDefined(response.data.error) ||
        angular.isDefined(response.data.errors))) {

        const error = response.data.error || response.data.errors;
        error.status = response.status;

        checkErrorResubmit(response);

        return $q.reject(error);

      } else if (angular.isDefined(response.data) && response.data === '') {

        return $q.reject(ERROR_MESSAGE);

      }

      return response;

    },

    responseError: (rejection) => {

      let error = ERROR_MESSAGE;
      const contentType = rejection.headers('content-type');

      // Backend is not responding accordingly or there is a network issue
      if (rejection.status === -1 || !contentType) {

        rejection.error = error;
        return $q.reject(rejection);

      }

      if (angular.isDefined(rejection.data)
        && typeof rejection.data !== 'string'
        && contentType.indexOf('application/json') === 0) {

        if (angular.isDefined(rejection.data.error)) {

          error = rejection.data.error;

        }

        // A getEvents() error object or technical errors.
        if (angular.isDefined(rejection.data.errors)) {

          error = rejection.data.errors;

          checkErrorResubmit(rejection);

        }

        if (typeof error !== 'string') error.status = rejection.status;

      }

      // Set error to rejection response.
      rejection.error = error;

      return $q.reject(rejection);

    }

  };

}

export default requestInterceptor;



// WEBPACK FOOTER //
// ./src/angular-services/parcels/request.interceptor.js